import { postForm } from "../hooks/useHttp";

export const getMajids = (page: number, userLocation: any) => {
  return postForm(`/masjid-nearby?page=${page}`, {
    latitude: userLocation[0],
    longitude: userLocation[1],
  });
};
